import { Heading } from '@orobix/orobix-fe-components'
import { version } from 'react'

import { vars } from '../../utils/appConfig'
import { getEnvs } from '../../utils/env'

const AppInfo = (): JSX.Element => {
  const feVersion = process.env.REACT_APP_GIT_VERSION
  const feGitSha = process.env.REACT_APP_GIT_SHA
  const { backendAppVersion, env } = getEnvs()

  return (
    <>
      <Heading headingLevel="2" headingLevelStyle="3" noTopMargin>
        {vars.appName}
      </Heading>
      <p>
        <b>React version:</b> {version}
        <br />
        {env && (
          <>
            <b>Environment:</b> {env}
          </>
        )}
        {feVersion && feGitSha && (
          <>
            <br />
            <b>Frontend:</b> {`${feVersion} (${feGitSha})`}
          </>
        )}
        {backendAppVersion && (
          <>
            <br />
            <b>Backend:</b> {backendAppVersion}
          </>
        )}
      </p>
    </>
  )
}

export default AppInfo
